import React, {useState} from "react";


export default function TextForm(props) {
    const [text, setText] = useState('');
    // text = "new text"; //Wrong way to change the state
    // setText("new text"); //Correct way to change the state
    const handleUpClick = () => {
        // console.log("Uppercase was clicked" + text);
        let newText = text.toUpperCase()
        setText(newText);
        props.showAlert("Converted to Uppercase!", "success")
    }

    const handleLoClick = () => {
        let newText = text.toLowerCase();
        setText(newText);
        props.showAlert("Converted to Lowercase!", "success")
    }

    const handleOnChange = (event) => {
        // console.log("OnChange");
        setText(event.target.value);
    }

    const handleClearClick = () => {
        let newText = '';
        setText(newText);
        props.showAlert("Cleared Text!", "success")
    }

    const speak = () => {
        let msg = new SpeechSynthesisUtterance();
        msg.text = text;
        window.speechSynthesis.speak(msg);
        props.showAlert("Pronounced Text!", "success")
      }

    const handleReverse = () => {
        let strArr = text.split("");
        strArr = strArr.reverse();
        let newText = strArr.join("");
        setText(newText);
        props.showAlert("Reversed Text!", "success")
    }

    const handleCopy = () => {
      // console.log("I am copy");
      // var text = document.getElementById("myBox");
      // text.select();
      navigator.clipboard.writeText(text);
      // document.getSelection().removeAllRanges();
      props.showAlert("Copied to Clipboard!", "success")
    }

    const handleExtraSpaces = () => {
      let newText = text.split(/[ ]+/);
      setText(newText.join(" "));
      props.showAlert("Removed Extra spaces!", "success")
    }

  return (
      <>
    <div className="container" style = {{color: props.mode === 'dark'?'white':'#4D4D4D'}}>
        <h1>{props.heading}</h1>
      <div className="mb-3">
        <textarea
          className="form-control"
          id="myBox"
          rows="8"
          placeholder="Enter text here"
          value={text}
          onChange = {handleOnChange}
          style = {{backgroundColor: props.mode === 'dark'?'#4D4D4D':'white',
          color: props.mode === 'dark'?'white':'#4D4D4D'
        }}
        ></textarea> 
      </div>
      <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 rounded-pill" style={{border:'solid black 2px'}} onClick={handleUpClick}>Convert to Uppercase</button>
      <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 rounded-pill" style={{border:'solid black 2px'}} onClick={handleLoClick}>Convert to Lowercase</button>
      <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 rounded-pill" style={{border:'solid black 2px'}} onClick={handleClearClick}>Clear Text</button>
      <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 rounded-pill" style={{border:'solid black 2px'}}onClick={speak}>Speak</button>
      <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 rounded-pill" style={{border:'solid black 2px'}}onClick={handleReverse}>Reverse Text</button>
      <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 rounded-pill" style={{border:'solid black 2px'}}onClick={handleCopy}>Copy Text</button>
      <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 rounded-pill" style={{border:'solid black 2px'}}onClick={handleExtraSpaces}>Remove Extra Spaces</button>
    </div>
    <div className="container my-3" style = {{color: props.mode === 'dark'?'white':'#4D4D4D'}} >
        <h2 className= "mb-2">Your text Summary</h2>
        <p>{text.split(/\s+/).filter((element) => {return element.length!==0}).length} words and {text.length} characters</p>
        <p>{0.008 * text.split(" ").filter((element) => {return element.length!==0}).length} Minutes read</p>
        <h2>Preview</h2>
        <p>{text.length>0?text:"Enter text to preview!"}</p>
    </div>
    </>
  );
}
